import React from 'react';

export const AuthContext = React.createContext({
  user: null,
  fetch: () => {},
  logout: () => {}
});

export default AuthContext;